import React from 'react';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import ui from '../../common/services/ui';
import { withTranslation } from 'react-i18next';

const PriceList = ({ t, lessonCount, paymentTypes, enableTermPrice, enableTrials, ...rest }) => {
	const columns = [
		{
			header: t('Center_Term'),
			accessor: 'term.name'
		},
		{
			header: t('Center_Grade'),
			accessor: 'grade.name'
		},
		{
			header: t('Center_PricePerLesson'),
			accessor: 'pricePerLesson',
			cell: value => ui.formatAmount(value)
		}
	];

	if (paymentTypes.some(p => p.name === 'NormalMonth')) {
		columns.push({
			header: t('Center_FourLessonPackagePricePerLesson'),
			accessor: 'fourLessonPackagePricePerLesson',
			cell: value => ui.formatAmount(value)
		});
	}

	if (paymentTypes.some(p => p.name === 'NormalSingle')) {
		columns.push({
			header: t('Center_SingleLessonPrice'),
			accessor: 'singleLessonPrice',
			cell: value => ui.formatAmount(value)
		});
	}

	if (paymentTypes.some(p => p.name === 'Annual')) {
		columns.push({
			header: t('Center_AnnualPrice', { lessonCount: lessonCount }),
			accessor: 'annualPrice',
			cell: value => ui.formatAmount(value)
		});
	}

	if (enableTermPrice) {
		columns.push({
			header: t('Price_TermPrice'),
			accessor: 'termPrice',
			cell: value => value !== null ? ui.formatAmount(value) : 'N/A'
		})
	}
	if (enableTrials) {
		columns.push({
			header: t('Price_TrialLessonPrice'),
			accessor: 'trialLessonPrice',
			cell: value => value !== null ? ui.formatAmount(value) : t('Price_UseCenterDefault')
		})
	}

	return (
		<div>		
			<PagedEntitiesList columns={columns} {...rest} />
		</div>
	);
};

export default withTranslation()(PriceList);